/**
 * Place this plugin in your plugins/ directory and include it in nuxt.config.js.
 * You will only need this plugin if your application runs in static mode -- it forces nuxt to fetch content from the API instead of using cached/generated data.
 */
export default async function({ enablePreview, query }) {
    if (query['x-craft-live-preview']) {
        await enablePreview();
    }
}
